import { useEffect, useRef, useState } from 'react';

/** Open/close transition timing for modals — keep in sync with the CSS duration. */
export const SHEET_MS = 340;

/** Drives a modal's enter/exit animation. `visible` flips true one frame after
 *  mount (so a modal that mounts already open still animates in), and `dismiss`
 *  animates out, then calls `onClose` (which typically unmounts us) after the
 *  animation. Route every close path (X, backdrop, swipe, native back) through
 *  `dismiss` so it always animates. */
export function useSheetTransition(onClose: () => void) {
  const [visible, setVisible] = useState(false);
  const closing = useRef(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const dismiss = () => {
    if (closing.current) return;
    closing.current = true;
    setVisible(false);
    window.setTimeout(onClose, SHEET_MS);
  };

  return { visible, dismiss };
}
